<template>
	<datatable :value="items" :headers expandable status-key="journey" :loading>
		<template #row-status="{ row }">
			<div class="flex items-center mt-2 mb-2">
				<app-badge class="gap-2" size="small" :theme="getStatusClass(row.status)">
					{{ row.status }}
				</app-badge>
			</div>
		</template>

		<template #row-quantity_required="{ row }">
			{{ Number(row.quantity_required).toFixed(0) }}
		</template>

		<template #row-quantity_confirmed="{ row }">
			{{ Number(row.quantity_confirmed).toFixed(0) }}
		</template>

		<template #row-weight="{ row }">
			{{ (row.weight * 1000).toFixed(1) }}
		</template>
	</datatable>
</template>

<script lang="ts" setup>
	import type { Header } from '@/data/types/datatable'
	import type { JourneyItem } from '@/data/schema/journey-item'
	import { getStatusClass } from '@/composables/datatable'

	defineProps({
		items: {
			type: Array<JourneyItem>,
			default: []
		},
		loading: Boolean
	})

	const headers: Header[] = [
		{ value: 'status', text: 'Status', props: { width: 100 } },
		{ value: 'item_number', text: 'Item No', props: { sortable: true, width: 100 } },
		{ value: 'item_description', text: 'Item Description', props: { width: 300 } },
		{ value: 'type', text: 'Type', props: { sortable: true } },
		{ value: 'quantity_required', text: 'Qty Req', props: { sortable: true } },
		{ value: 'quantity_confirmed', text: 'Qty Conf', props: { sortable: true } },
		{ value: 'weight', text: 'Weight', props: { sortable: true } }
	]
</script>
